// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-connector-wizard {
  min-height: 100vh;
  background-color: #f8fafc;
  padding: 2rem;
}

.wizard-container {
  max-width: 1200px;
  margin: 0 auto;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.wizard-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  gap: 1rem;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #e5e7eb;
  border-top: 4px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.error-message,
.success-message {
  padding: 1rem;
  margin: 1rem;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.error-message {
  background-color: #fef2f2;
  color: #dc2626;
  border: 1px solid #fecaca;
}

.success-message {
  background-color: #f0fdf4;
  color: #16a34a;
  border: 1px solid #bbf7d0;
}

.wizard-content {
  padding: 2rem;
}

/* Authenticate Step */
.authenticate-step .step-header {
  text-align: center;
  margin-bottom: 3rem;
}

.authenticate-step h1 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 0.5rem;
}

.authenticate-step p {
  color: #6b7280;
  font-size: 1.1rem;
}

.platforms-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  max-width: 800px;
  margin: 0 auto;
}

.platform-card {
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  min-width: 200px;
  transition: all 0.2s;
}

.platform-card:hover {
  border-color: #d1d5db;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.platform-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
}

.platform-icon.hubspot {
  background-color: #ff7a59;
}

.platform-icon.salesforce {
  background-color: #00a1e0;
}

.platform-card h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.5rem;
}

.connection-status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  font-size: 0.875rem;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.connection-status.connected {
  color: #16a34a;
}

.connection-status.connected .status-dot {
  background-color: #16a34a;
}

.connection-status.not-connected {
  color: #dc2626;
}

.connection-status.not-connected .status-dot {
  background-color: #dc2626;
}

.connect-button {
  width: 100%;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.2s;
  border: none;
  cursor: pointer;
}

.connect-button:not(.connected) {
  background-color: #3b82f6;
  color: white;
}

.connect-button:not(.connected):hover:not(:disabled) {
  background-color: #2563eb;
}

.connect-button.connected {
  background-color: #16a34a;
  color: white;
}

.connect-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.sync-arrows {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Field Mapping Step */
.field-mapping-step .step-header {
  text-align: center;
  margin-bottom: 2rem;
}

.field-mapping-step h1 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 1rem;
}

.mapping-section h2 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.5rem;
}

.mapping-description {
  color: #6b7280;
  margin-bottom: 2rem;
}

.mapping-headers {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  padding: 1rem;
  background-color: #f9fafb;
  border-radius: 8px;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #374151;
}

.mappings-list {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

.mapping-row {
  display: grid;
  grid-template-columns: 1fr auto 1fr auto;
  gap: 1rem;
  padding: 1rem;
  align-items: center;
  border-bottom: 1px solid #e5e7eb;
}

.mapping-row:last-child {
  border-bottom: none;
}

.mapping-row.add-form {
  background-color: #f0f9ff;
  border: 2px solid #3b82f6;
}

.field-input,
.field-select {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.875rem;
}

.field-input:read-only {
  background-color: #f9fafb;
}

.mapping-arrow {
  color: #6b7280;
  font-size: 1.25rem;
  text-align: center;
}

.remove-button {
  background: none;
  border: none;
  color: #dc2626;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 4px;
  transition: all 0.2s;
}

.remove-button:hover {
  background-color: #fef2f2;
}

.add-form-actions {
  display: flex;
  gap: 0.5rem;
}

.save-button,
.cancel-button {
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.save-button {
  background-color: #16a34a;
  color: white;
  border: none;
}

.save-button:hover:not(:disabled) {
  background-color: #15803d;
}

.save-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.cancel-button {
  background-color: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
}

.cancel-button:hover {
  background-color: #e5e7eb;
}

.add-mapping-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  margin-top: 1rem;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.add-mapping-button:hover {
  background-color: #2563eb;
}

.mapping-summary {
  margin-top: 2rem;
  padding: 1rem;
  background-color: #f9fafb;
  border-radius: 8px;
}

.summary-stats {
  display: flex;
  gap: 2rem;
  justify-content: center;
}

.stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
}

.stat-label {
  font-size: 0.875rem;
  color: #6b7280;
}

.stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1f2937;
}

/* Sync Rules Step */
.sync-rules-step .step-header {
  text-align: center;
  margin-bottom: 2rem;
}

.sync-rules-step h1 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
}

.sync-overview {
  margin-bottom: 2rem;
}

.platform-overview {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 1rem;
}

.platform-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.platform-item span {
  font-weight: 500;
  color: #374151;
}

.sync-arrows-horizontal {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sync-status {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sync-description {
  text-align: center;
  color: #6b7280;
  font-size: 1rem;
}

.sync-sections {
  max-width: 800px;
  margin: 0 auto;
}

.sync-section {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  margin-bottom: 1rem;
  overflow: hidden;
}

.section-header {
  width: 100%;
  padding: 1rem;
  background-color: #f9fafb;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
}

.section-header:hover {
  background-color: #f3f4f6;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.section-title h3 {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.expand-icon {
  color: #6b7280;
  transition: transform 0.2s;
}

.expand-icon.expanded {
  transform: rotate(90deg);
}

.section-content {
  padding: 1rem;
}

.rules-header {
  display: grid;
  grid-template-columns: 1fr auto 1fr auto;
  gap: 1rem;
  padding: 0.75rem;
  background-color: #f9fafb;
  border-radius: 6px;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #374151;
  font-size: 0.875rem;
}

.rules-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.rule-row {
  display: grid;
  grid-template-columns: 1fr auto 1fr auto;
  gap: 1rem;
  padding: 1rem;
  align-items: center;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  transition: all 0.2s;
}

.rule-row.enabled {
  background-color: #f0f9ff;
  border-color: #3b82f6;
  margin: 6px 0px;
}

.rule-row.disabled {
  background-color: #f9fafb;
  opacity: 0.7;
}

.rule-source,
.rule-target {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.rule-text {
  font-size: 0.875rem;
  color: #374151;
}

.rule-arrow {
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rule-toggle {
  display: flex;
  justify-content: center;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #d1d5db;
  transition: 0.2s;
  border-radius: 24px;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.2s;
  border-radius: 50%;
}

input:checked + .toggle-slider {
  background-color: #3b82f6;
}

input:checked + .toggle-slider:before {
  transform: translateX(20px);
}

/* Navigation */
.wizard-navigation {
  display: flex;
  justify-content: space-between;
  padding: 1.5rem 2rem;
  border-top: 1px solid #e5e7eb;
  background-color: #f9fafb;
}

.back-button,
.next-button {
  padding: 0.75rem 2rem;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.back-button {
  background-color: white;
  color: #374151;
  border: 1px solid #d1d5db;
}

.back-button:hover {
  background-color: #f9fafb;
}

.next-button {
  background-color: #3b82f6;
  color: white;
  border: none;
}

.next-button:hover:not(:disabled) {
  background-color: #2563eb;
}

.next-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Responsive Design */
@media (max-width: 768px) {
  .edit-connector-wizard {
    padding: 1rem;
  }

  .platforms-container {
    flex-direction: column;
    gap: 1rem;
  }

  .platform-card {
    min-width: auto;
    width: 100%;
    max-width: 300px;
  }

  .sync-arrows {
    transform: rotate(90deg);
  }

  .mapping-headers,
  .mapping-row,
  .rules-header,
  .rule-row {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }

  .mapping-arrow,
  .rule-arrow {
    transform: rotate(90deg);
  }

  .summary-stats {
    flex-direction: column;
    gap: 1rem;
  }

  .wizard-navigation {
    flex-direction: column;
    gap: 1rem;
  }
}
/* .edit-connector-wizard .rule-row:last-child {
  border-bottom: #3b82f6;
} */`, "",{"version":3,"sources":["webpack://./src/pages/Connector-Screen/Edit-Connector-Screen/EditConnectorWizard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;;;IAIE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;AACA;;GAEG","sourcesContent":[".edit-connector-wizard {\n  min-height: 100vh;\n  background-color: #f8fafc;\n  padding: 2rem;\n}\n\n.wizard-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.wizard-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  gap: 1rem;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #e5e7eb;\n  border-top: 4px solid #3b82f6;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.error-message,\n.success-message {\n  padding: 1rem;\n  margin: 1rem;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.error-message {\n  background-color: #fef2f2;\n  color: #dc2626;\n  border: 1px solid #fecaca;\n}\n\n.success-message {\n  background-color: #f0fdf4;\n  color: #16a34a;\n  border: 1px solid #bbf7d0;\n}\n\n.wizard-content {\n  padding: 2rem;\n}\n\n/* Authenticate Step */\n.authenticate-step .step-header {\n  text-align: center;\n  margin-bottom: 3rem;\n}\n\n.authenticate-step h1 {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #1f2937;\n  margin-bottom: 0.5rem;\n}\n\n.authenticate-step p {\n  color: #6b7280;\n  font-size: 1.1rem;\n}\n\n.platforms-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 2rem;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.platform-card {\n  background: white;\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 2rem;\n  text-align: center;\n  min-width: 200px;\n  transition: all 0.2s;\n}\n\n.platform-card:hover {\n  border-color: #d1d5db;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.platform-icon {\n  width: 60px;\n  height: 60px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 1rem;\n}\n\n.platform-icon.hubspot {\n  background-color: #ff7a59;\n}\n\n.platform-icon.salesforce {\n  background-color: #00a1e0;\n}\n\n.platform-card h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 0.5rem;\n}\n\n.connection-status {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n  font-size: 0.875rem;\n}\n\n.status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n.connection-status.connected {\n  color: #16a34a;\n}\n\n.connection-status.connected .status-dot {\n  background-color: #16a34a;\n}\n\n.connection-status.not-connected {\n  color: #dc2626;\n}\n\n.connection-status.not-connected .status-dot {\n  background-color: #dc2626;\n}\n\n.connect-button {\n  width: 100%;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-weight: 500;\n  transition: all 0.2s;\n  border: none;\n  cursor: pointer;\n}\n\n.connect-button:not(.connected) {\n  background-color: #3b82f6;\n  color: white;\n}\n\n.connect-button:not(.connected):hover:not(:disabled) {\n  background-color: #2563eb;\n}\n\n.connect-button.connected {\n  background-color: #16a34a;\n  color: white;\n}\n\n.connect-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.sync-arrows {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Field Mapping Step */\n.field-mapping-step .step-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.field-mapping-step h1 {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #1f2937;\n  margin-bottom: 1rem;\n}\n\n.mapping-section h2 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 0.5rem;\n}\n\n.mapping-description {\n  color: #6b7280;\n  margin-bottom: 2rem;\n}\n\n.mapping-headers {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n  padding: 1rem;\n  background-color: #f9fafb;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n.mappings-list {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.mapping-row {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr auto;\n  gap: 1rem;\n  padding: 1rem;\n  align-items: center;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.mapping-row:last-child {\n  border-bottom: none;\n}\n\n.mapping-row.add-form {\n  background-color: #f0f9ff;\n  border: 2px solid #3b82f6;\n}\n\n.field-input,\n.field-select {\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 0.875rem;\n}\n\n.field-input:read-only {\n  background-color: #f9fafb;\n}\n\n.mapping-arrow {\n  color: #6b7280;\n  font-size: 1.25rem;\n  text-align: center;\n}\n\n.remove-button {\n  background: none;\n  border: none;\n  color: #dc2626;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n\n.remove-button:hover {\n  background-color: #fef2f2;\n}\n\n.add-form-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.save-button,\n.cancel-button {\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.save-button {\n  background-color: #16a34a;\n  color: white;\n  border: none;\n}\n\n.save-button:hover:not(:disabled) {\n  background-color: #15803d;\n}\n\n.save-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.cancel-button {\n  background-color: #f3f4f6;\n  color: #374151;\n  border: 1px solid #d1d5db;\n}\n\n.cancel-button:hover {\n  background-color: #e5e7eb;\n}\n\n.add-mapping-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  margin-top: 1rem;\n  background-color: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.add-mapping-button:hover {\n  background-color: #2563eb;\n}\n\n.mapping-summary {\n  margin-top: 2rem;\n  padding: 1rem;\n  background-color: #f9fafb;\n  border-radius: 8px;\n}\n\n.summary-stats {\n  display: flex;\n  gap: 2rem;\n  justify-content: center;\n}\n\n.stat {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.stat-label {\n  font-size: 0.875rem;\n  color: #6b7280;\n}\n\n.stat-value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1f2937;\n}\n\n/* Sync Rules Step */\n.sync-rules-step .step-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.sync-rules-step h1 {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #1f2937;\n}\n\n.sync-overview {\n  margin-bottom: 2rem;\n}\n\n.platform-overview {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 2rem;\n  margin-bottom: 1rem;\n}\n\n.platform-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.platform-item span {\n  font-weight: 500;\n  color: #374151;\n}\n\n.sync-arrows-horizontal {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sync-status {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sync-description {\n  text-align: center;\n  color: #6b7280;\n  font-size: 1rem;\n}\n\n.sync-sections {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.sync-section {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n  overflow: hidden;\n}\n\n.section-header {\n  width: 100%;\n  padding: 1rem;\n  background-color: #f9fafb;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.section-header:hover {\n  background-color: #f3f4f6;\n}\n\n.section-title {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.section-title h3 {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0;\n}\n\n.expand-icon {\n  color: #6b7280;\n  transition: transform 0.2s;\n}\n\n.expand-icon.expanded {\n  transform: rotate(90deg);\n}\n\n.section-content {\n  padding: 1rem;\n}\n\n.rules-header {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr auto;\n  gap: 1rem;\n  padding: 0.75rem;\n  background-color: #f9fafb;\n  border-radius: 6px;\n  margin-bottom: 1rem;\n  font-weight: 600;\n  color: #374151;\n  font-size: 0.875rem;\n}\n\n.rules-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.rule-row {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr auto;\n  gap: 1rem;\n  padding: 1rem;\n  align-items: center;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  transition: all 0.2s;\n}\n\n.rule-row.enabled {\n  background-color: #f0f9ff;\n  border-color: #3b82f6;\n  margin: 6px 0px;\n}\n\n.rule-row.disabled {\n  background-color: #f9fafb;\n  opacity: 0.7;\n}\n\n.rule-source,\n.rule-target {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.rule-text {\n  font-size: 0.875rem;\n  color: #374151;\n}\n\n.rule-arrow {\n  color: #6b7280;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.rule-toggle {\n  display: flex;\n  justify-content: center;\n}\n\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 44px;\n  height: 24px;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #d1d5db;\n  transition: 0.2s;\n  border-radius: 24px;\n}\n\n.toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.2s;\n  border-radius: 50%;\n}\n\ninput:checked + .toggle-slider {\n  background-color: #3b82f6;\n}\n\ninput:checked + .toggle-slider:before {\n  transform: translateX(20px);\n}\n\n/* Navigation */\n.wizard-navigation {\n  display: flex;\n  justify-content: space-between;\n  padding: 1.5rem 2rem;\n  border-top: 1px solid #e5e7eb;\n  background-color: #f9fafb;\n}\n\n.back-button,\n.next-button {\n  padding: 0.75rem 2rem;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.back-button {\n  background-color: white;\n  color: #374151;\n  border: 1px solid #d1d5db;\n}\n\n.back-button:hover {\n  background-color: #f9fafb;\n}\n\n.next-button {\n  background-color: #3b82f6;\n  color: white;\n  border: none;\n}\n\n.next-button:hover:not(:disabled) {\n  background-color: #2563eb;\n}\n\n.next-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .edit-connector-wizard {\n    padding: 1rem;\n  }\n\n  .platforms-container {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .platform-card {\n    min-width: auto;\n    width: 100%;\n    max-width: 300px;\n  }\n\n  .sync-arrows {\n    transform: rotate(90deg);\n  }\n\n  .mapping-headers,\n  .mapping-row,\n  .rules-header,\n  .rule-row {\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n  }\n\n  .mapping-arrow,\n  .rule-arrow {\n    transform: rotate(90deg);\n  }\n\n  .summary-stats {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .wizard-navigation {\n    flex-direction: column;\n    gap: 1rem;\n  }\n}\n/* .edit-connector-wizard .rule-row:last-child {\n  border-bottom: #3b82f6;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
